import React, { useCallback, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { KeyIcon } from "@heroicons/react/24/outline";
import { useAccount } from "../account/AccountContext";
import { getRecentStoreOrders, rememberOrderToken } from "../visoria/order-storage";
import { getOtherStoreDefinition } from "../visoria/stores";
import { useDismiss } from "./useDismiss";

const timeFormat = new Intl.DateTimeFormat("ru-RU", { hour: "2-digit", minute: "2-digit" });

/** Подсказка «Где мой код?»: заказы из этой вкладки, кабинет и поддержка. */
export function OrderHelpContent({ onNavigate }) {
  const { account } = useAccount();
  const orders = getRecentStoreOrders();

  return (
    <div className="order-help">
      <p className="order-help-title">Где мой код?</p>
      <p className="order-help-text">
        Код появляется на странице заказа сразу после оплаты и приходит на почту, указанную при
        покупке. Если письма нет — проверьте папку «Спам».
      </p>
      {orders.length ? (
        <div className="order-help-orders">
          <p className="order-help-subtitle">Заказы в этой вкладке</p>
          {orders.map((order) => (
            <Link
              key={order.orderId}
              to={`/store/order/${encodeURIComponent(order.orderId)}`}
              className="order-help-order"
              onClick={() => {
                rememberOrderToken(order.orderId, order.accessToken);
                onNavigate?.();
              }}
            >
              <span>{getOtherStoreDefinition(order.storeId)?.pageTitle || order.storeId}</span>
              {order.savedAt ? <span className="order-help-muted">{timeFormat.format(order.savedAt)}</span> : null}
            </Link>
          ))}
        </div>
      ) : null}
      <Link to="/account" className="order-help-account" onClick={() => onNavigate?.()}>
        {account ? "Открыть мои заказы и коды" : "Все заказы на вашу почту — войти в кабинет"}
      </Link>
      <p className="order-help-text">
        Не нашли код?{" "}
        <a href={process.env.REACT_APP_SUPPORT_TG_URL} target="_blank" rel="noreferrer" className="order-help-link">
          Напишите в поддержку
        </a>{" "}
        и укажите номер заказа.
      </p>
    </div>
  );
}

/** Кнопка в шапке на компьютере. */
export function OrderHelpButton() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const close = useCallback(() => setOpen(false), []);
  useDismiss(ref, open, close);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        className="header-text-btn"
        aria-expanded={open}
        aria-haspopup="dialog"
        title="Где мой код?"
        onClick={() => setOpen((value) => !value)}
      >
        <KeyIcon className="h-5 w-5" aria-hidden="true" />
        <span className="sr-only">Где мой код?</span>
      </button>
      {open ? (
        <div className="header-popover header-popover-right w-80" role="dialog" aria-label="Где мой код?">
          <OrderHelpContent onNavigate={close} />
        </div>
      ) : null}
    </div>
  );
}
